export const copyToClipboard = (text, setIsCopied) => {
  try {
    navigator && navigator.clipboard.writeText(text.toString());
    setIsCopied && setIsCopied(true);
  } catch (e) {}
};
